import { useCallback, useContext } from 'react';
import { ConversationItem } from '@zg-rentals/satellite-components';
import PropertyThumbnailWithAvatar from '../../PropertyThumbnailWithAvatar';
import { CONVERSATION_ITEM_CLICK_EVENT_TYPE_ID } from '../../../constants/clickstreamEvents/conversationItemClick';
import { InboxPageContext } from '../../../contexts/InboxPageContextProvider';
import useWindowSize from '../../../hooks/useWindowSize';
import type { ConversationInConversationList } from '../index';

type ConversationItemContainerProps = {
  conversation: ConversationInConversationList;
  onClick: (conversationId: string) => void;
};

export default function ConversationItemContainer({ conversation, onClick }: ConversationItemContainerProps) {
  const { conversationId: conversationIdFromUrl } = useContext(InboxPageContext);
  const { isDesktopView } = useWindowSize();
  const {
    address,
    conversation: messages,
    conversationId,
    hasUnreadMessage,
    landlordName,
    listingName,
    status,
    photoUrl,
  } = conversation;

  const latestMessageDetails = messages?.length ? messages[messages.length - 1] : undefined;
  const { isMessageOwner, message, messageDateMs } = latestMessageDetails || {};
  const { isSpam, isArchived } = status || {};
  const addressDisplay = address ? address.split(',')[0] : '';
  const title = listingName || addressDisplay;
  const isSelected = conversationIdFromUrl === conversationId && isDesktopView;

  const handleClick = useCallback(() => {
    onClick(conversationId ?? '');
  }, [onClick, conversationId]);

  return (
    <ConversationItem
      key={conversationId}
      dataEventId={CONVERSATION_ITEM_CLICK_EVENT_TYPE_ID}
      isArchived={isArchived}
      isMessageOwner={isMessageOwner ?? false}
      isPhoneLead={false}
      isSelected={isSelected}
      isSpamOrReported={isSpam}
      isUnread={hasUnreadMessage}
      latestMessage={message ?? ''}
      latestMessageDateMs={messageDateMs ?? ''}
      onClick={handleClick}
      subtitle={landlordName ?? ''}
      thumbnail={<PropertyThumbnailWithAvatar photoUrl={photoUrl} avatarName={landlordName} />}
      title={title}
    />
  );
}
